export default __webpack_public_path__ + "static/media/left_dark.eb698b81.png";